import InvestStrategyForm from './InvestStrategyForm';

export default InvestStrategyForm;
